import { createFileRoute } from '@tanstack/react-router';
import { fundingListSearchSchema } from '@/pages/ai-matching-results/lib/fundingListSearchSchema';
import { NationalGrantsPage } from '@/pages/ai-matching-results/ui/NationalGrantsPage';

export const Route = createFileRoute('/_protected/projects/ai-matching-results/national-grants/')({
  component: NationalGrantsPage,
  validateSearch: (search) => fundingListSearchSchema.parse(search),
});
